import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.benchmarkStudy.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.benchmarkStudy.fields.name'),
  },
  {
    name: 'methodology',
    label: i18n('entities.benchmarkStudy.fields.methodology'),
  },
  {
    name: 'startDate',
    label: i18n('entities.benchmarkStudy.fields.startDate'),
  },
  {
    name: 'endDate',
    label: i18n('entities.benchmarkStudy.fields.endDate'),
  },
  {
    name: 'conductedBy',
    label: i18n('entities.benchmarkStudy.fields.conductedBy'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.benchmarkStudy.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.benchmarkStudy.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
